module.exports = __webpack_public_path__ + "img/epul.ee21ac9e.svg";